
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-4749.48 -5020 35.036 35.036"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0-399.479h17.555v17.555H0z","transform":"translate(0 399.479)","fill":"none"}})])]),_c('g',{attrs:{"transform":"translate(-4886 -5075)"}},[_c('circle',{attrs:{"cx":"17.518","cy":"17.518","r":"17.518","transform":"translate(136.52 55)","fill":"#4e8cff"}}),_c('g',{attrs:{"clip-path":"url(#a)","transform":"translate(145.13 64)"}},[_c('path',{attrs:{"d":"M17.555 8.778A8.778 8.778 0 008.777 0 8.778 8.778 0 00-.001 8.778a8.745 8.745 0 002.26 5.879v1.442c0 .8.492 1.457 1.1 1.457h5.83a.843.843 0 00.183-.02 8.778 8.778 0 008.184-8.757","fill":"#fff"}}),_c('path',{attrs:{"d":"M3.161 8.921A9.292 9.292 0 019.541.033 8.763 8.763 0 008.778 0 8.774 8.774 0 000 8.778 9.508 9.508 0 002.224 14.7c.005 0 0 .009 0 .01-.311.352-1.924 2.849.021 2.849h2.25c-1.23-.022 1.263-2.107.269-3.494a8.225 8.225 0 01-1.6-5.141","fill":"#eff4f9"}})])])])
          )
        }
      }
    